import { sendToAndroid } from '../../../utils/android-bridge';
import { isPlatformBrowser } from '@angular/common';
import { Component, OnInit, PLATFORM_ID, importProvidersFrom, Inject, inject, DOCUMENT } from '@angular/core';
import {MatIcon} from "@angular/material/icon";
import { AngularDeviceInformationService } from 'angular-device-information';
import { TranslateService } from '@ngx-translate/core'
import { TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { SessionAnalyticsService } from '../../../Services/session-analytics.service';
import { TrackerService } from '../../../Services/trackerService';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@Component({
    selector: 'app-404',
    imports: [
        MatIcon,
        TranslateModule
    ],
    templateUrl: './404.component.html',
    styleUrl: './404.component.less'
})
export class NotFondComponent implements OnInit {
  Sessiondata: any;
  constructor(
    private deviceInformationService: AngularDeviceInformationService,
    private translateService: TranslateService,
    private sessionAnalyticsService: SessionAnalyticsService,
    private trackerService: TrackerService,
    
  ) {}

  sendInfoNative(payload:{"action":string}){
    try {
            sendToAndroid(payload.action);

    } catch (error) {

    }
  }

  platformId = inject(PLATFORM_ID);

  ngOnInit(): void {
    let lang = localStorage.getItem('lang') ?? "en";
    this.translateService.setDefaultLang(lang);
    this.translateService.use(lang);
    if (isPlatformBrowser(this.platformId))
      {
       const payload = {"action":"completed"};
       window.parent.postMessage(payload, "*" )
       this.sendInfoNative(payload)
    }
  }

  PostAction() {
    const payload = {"action": "refresh"};
    window.parent.postMessage(payload, "*");
    this.sendInfoNative(payload);
  }

}